<template>
  <div class="historical_card">
    <div class="item_title_student" v-if="isStudent">
      <p>{{cardValue.typeText || ''}}</p>
      <div :class="[cardValue.replyStatusValue=='1'?'status_color':'']">{{cardValue.replyStatusText || '无'}}</div>
    </div>
    <div v-else class="item_title_teacher">
      <div class="teacher_title">
        <van-image radius="50%" width="48" height="48" fit="cover" :src="cardValue.photo | imgFormat">
          <template v-slot:error>
            <img :src="defaultImg | imgFormat" alt="" class="err_img">
          </template>
        </van-image>
        <div class="teacher_info">
          <p class="info_name">{{cardValue.stuName || ''}}</p>
          <span class="info_class">{{cardValue.className || ''}}</span>
        </div>
      </div>
      <div class="info_status">{{cardValue.typeText || ''}}</div>
    </div>
    <div class="item_content">{{cardValue.suggest || ''}}</div>
    <div class="item_img">
      <van-image v-for="(item,index) of imgUrl()" :key="index" radius="5" width="80" height="80" fit="cover" :src="item.relativePath">
        <template v-slot:error>
          <img :src="require('../../assets/styles/themes/img/submissionErr_mobile.png')" alt="" class="err_img">
        </template>
      </van-image>
    </div>
    <div class="item_reply" v-if="cardValue.suggestReplyList && cardValue.suggestReplyList.length">
      <span>回复内容：</span>
      <div>{{cardValue.suggestReplyList[0].detail || ''}}</div>
    </div>
    <div class="item_date">
      <div>提交日期：{{cardValue.dsCreateTime || ''}}</div>
      <span @click="toDetailUrl">详情</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfHistoricalSubmissionCard",
  ctrlCaption: "历史提交卡片",
  data() {
    return {
      defaultImg: dsf.config.setting_public_user_default_header,
    }
  },
  props: {
    isStudent: {
      type: Boolean,
      default: true
    },
    cardValue: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    imgUrl() {
      if (this.cardValue.attachment) {
        let imgArr = JSON.parse(this.cardValue.attachment);
        return imgArr
      } else {
        return []
      }
    },
    toDetailUrl() {
      var url = '#/mobile/teas/classes/suggest/mobile/mobile-historicalsubmissiondetails?id=' + this.cardValue.id
      if (!this.isStudent) {
        url = '#/mobile/teas/classes/suggest/mobile/mobile-headmasterhistoricalsubmissiondetails?id=' + this.cardValue.id
      }
      this.$open({
        url,
        state: 1
      })
    }
  },
  created() {
  }
}
</script>

<style>
</style>